// Deep import on purpose: the barrel would eagerly load the lazy timeline feature into the core bundle
import { clearTrackDecisionSessionState } from '@features/timeline/features/track-agronomic-decision/track-decision-session-dismissals';
import type { Dictionary } from '@protector/utils/types';
import { OAUTH_CROPWISE_URL } from 'config/constants';
import { LogoutRequest } from 'core/services/auth/auth.actions';
import type { SegmentTrackingHookReturn } from 'core/utils/segment/useSegmentTracking';
import type { Dispatch } from 'redux';

interface HandleLogoutProps {
  segmentTracking: SegmentTrackingHookReturn;
  systemFlags: Dictionary<string | boolean> | null;
  dispatch: Dispatch;
}

export const handleLogout = ({ segmentTracking, systemFlags, dispatch }: HandleLogoutProps) => {
  segmentTracking.track(`User Settings - Logout`);

  if (systemFlags?.CWS_10071_OKTA_LOGOUT) {
    try {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('refresh_token');
      sessionStorage.removeItem('company_id');
      clearTrackDecisionSessionState();

      window.location.replace(`${OAUTH_CROPWISE_URL}/exit?continue=${window.location.origin}`);
    } catch (error) {
      console.log('Error on logout', error);
    }
  } else {
    dispatch(LogoutRequest());
  }
};
